import script from "./policy-select.vue?vue&type=script&lang=ts&setup=true"
export * from "./policy-select.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__